import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { TIPOS_GASTO_606 } from "@/lib/retentions";

// Registra un e-CF recibido como gasto (luz, internet, alquiler…) sin tocar inventario.
export function ConvertExpenseDialog({ row, onClose, onDone }) {
  const [categories, setCategories] = useState([]);
  const [f, setF] = useState({ category: "", payment_method: "transferencia", tipo_gasto_606: "02" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/expense-categories").then(({ data }) => setCategories(data)); }, []);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/ecf-recibidos/${row.id}/convert-expense`, f);
      toast.success(`Gasto ${data.expense_number} registrado`);
      onDone();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };
  const sel = "mt-1 w-full h-9 rounded-md border border-input bg-transparent px-3 text-sm";
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="convert-expense-dialog">
        <DialogHeader><DialogTitle>Registrar {row.encf} como gasto</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">Para facturas que no son mercancía (servicios, reparaciones, oficina). No suma existencia.</p>
        <div className="space-y-3">
          <div><Label className="overline">Categoría de gasto</Label>
            <select className={sel} value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} data-testid="convert-expense-category">
              <option value="">Otros gastos</option>
              {categories.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
            </select></div>
          <div><Label className="overline">Pagado con</Label>
            <select className={sel} value={f.payment_method} onChange={(e) => setF({ ...f, payment_method: e.target.value })} data-testid="convert-expense-payment">
              <option value="transferencia">Transferencia</option><option value="efectivo">Efectivo</option>
              <option value="cheque">Cheque</option><option value="tarjeta">Tarjeta</option>
            </select></div>
          <div><Label className="overline">Tipo de gasto (606)</Label>
            <select className={sel} value={f.tipo_gasto_606} onChange={(e) => setF({ ...f, tipo_gasto_606: e.target.value })} data-testid="convert-expense-606">
              {TIPOS_GASTO_606.map((x) => <option key={x.value} value={x.value}>{x.label}</option>)}
            </select></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button className="bg-primary font-bold" disabled={busy} onClick={save} data-testid="convert-expense-save">Registrar gasto</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
